import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft, Search } from "tabler-icons-react";

function NotFoundPage() {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate("/");
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex flex-col items-center justify-center p-6">
            {/* Illustration 404 */}
            <div className="relative mb-6">
                <div className="text-8xl font-bold text-primary/20 select-none">
                    404
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center">
                        <Search size={40} className="text-primary" />
                    </div>
                </div>
            </div>

            {/* Titre */}
            <h1 className="text-2xl font-bold text-gray-800 text-center mb-2">
                Page introuvable
            </h1>

            {/* Message */}
            <p className="text-gray-600 text-center max-w-sm mb-2">
                Oups ! La page que vous cherchez n'existe pas ou a été déplacée.
            </p>

            <p className="text-gray-500 text-sm text-center max-w-sm mb-8">
                Pas de panique, retournez à l'accueil pour continuer à utiliser Genimi.
            </p>

            {/* Boutons d'action */}
            <div className="flex flex-col sm:flex-row gap-4 w-full max-w-sm">
                <button
                    onClick={handleGoHome}
                    className="flex-1 bg-primary text-white px-6 py-4 rounded-full flex items-center justify-center gap-2 text-lg font-semibold hover:bg-primary/90 transition-colors shadow-lg"
                >
                    <Home size={24} />
                    Accueil
                </button>

                <button
                    onClick={handleGoBack}
                    className="flex-1 bg-white text-gray-700 px-6 py-4 rounded-full flex items-center justify-center gap-2 text-lg font-semibold border-2 border-gray-200 hover:bg-gray-50 transition-colors"
                >
                    <ArrowLeft size={24} />
                    Retour
                </button>
            </div>

            {/* Footer */}
            <p className="mt-10 text-gray-400 text-xs text-center">
                Genimi - Votre partenaire éducatif
            </p>
        </div>
    );
}

export default NotFoundPage;
